import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Item } from './item';
import { UtilService} from "../util.service";
import { ProductsService } from '../../_services/index'
import { AdminAlertsService } from 'app/admin/alerts/admin-alerts.service';
import { NotificationsService } from '../../notifications/notifications.service';
import { NavbarNode, User } from '../model/index';
import { Observable, Subscription } from 'rxjs';
import { NavbarService } from 'app/_services/navbar.service';
import { NavbarChildrenVisibilityService } from 'app/_services/navbar-children-visibility.service';
import { OtasErrors } from '../model/admin/ota.model';
import { AdminCustomerService } from 'app/admin/customers/admin-customer.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { MANUAL_GOOGLE_FB } from '../utils/statics/manual-links.static';
import { Select, Store } from '@ngxs/store';
import { StoreChainOtasErrors } from 'app/states/otas/otas.actions';
import { CustomersState } from 'app/states/customers/customers.state';
import { OtasState } from 'app/states/otas/otas.state';
import { Router } from '@angular/router';
import { distinctUntilChanged, filter, take } from 'rxjs/operators';
import { MenusState } from 'app/states/menus/menus.state';
import { SessionService } from 'app/layouts/themes/session/session.service';
import { TreeRootComponent } from 'app/core-lib/navbar/tree-root/tree-root.component';
import { TreeModel, ITreeOptions } from 'app/core-lib/navbar/models/tree-model.model';
import { TreeWrapperNode } from 'app/core-lib/navbar/models/tree-wrapper-node.model';

@Component({
    selector: 'mh-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
    providers: [AdminCustomerService],
    standalone: false
})
export class NavbarComponent implements OnInit, OnDestroy {
  @Output()
  menuStatus: EventEmitter<boolean> = new EventEmitter<boolean>();

  @ViewChild('navbar_tree') treeComponent: TreeRootComponent;
  @ViewChild('StatusOTA') statusOTA: any;
  @ViewChild('StatusPMS') statusPMS: any;

  readonly EXTRA_SMALL_HEIGHT_RESOLUTION = 500;
  readonly SMALL_HEIGHT_RESOLUTION = 720;
  readonly MEDIUM_HEIGHT_RESOLUTION = 864;

  navItems: Item[] = [];
  products: any[] = [];
  currentUrl:string; //current section represent the Active Product
  productViews=[];
  productCategories=[];
  levelMenu
  nodes:NavbarNode[] = [];
  currentNode;
  isReady:boolean = false;
  util: UtilService;
  currentCustomerLogo;
  isLoading = false;
  isLoadingSubMenu = false;
  treeModel:TreeModel;
  is_super_admin: boolean = false;
  is_admin: boolean = false;
  currentUser: User;
  user_role;
  waitingIntegrationStatus:boolean = true;
  otasErrors: OtasErrors[] | null;
  showOtasErrors: boolean;
  showStates = true;
  showIntegrationState = false;
  isCollapsing = false;
  subscriptions: Subscription;
  options: ITreeOptions = {
    actionMapping: {
      mouse: {
        click: (tree: TreeModel, node: TreeWrapperNode, $event: MouseEvent) => {
          if (node.data.product === 'concierge') this.utilService.ga('', 'navigation_sidebar_click', null, null, { item_id: 'concierge' });
          if(node.data.depth === 0 && node.isCollapsed) tree.collapseAll();
          if(node.data.depth === 1 && node.hasChildren && node.isCollapsed && node.data.product !== 'concierge') {
            tree.roots.forEach(elem => {
              elem.children.forEach(subelem => {
                if(node.data.id !== subelem.id) {
                  const treeNode = tree.getNodeById(subelem.id);
                  if (treeNode) {
                    treeNode.collapseAll();
                  }
                }
              })
            })
          }

          if (node.data.depth === 2 && !node.hasChildren && tree.expandedNodes.length > 0) {
            tree.expandedNodes.forEach(subElement => {
              if (subElement.id === "/intercadena/online/cobertura" && node.id !== subElement.id) {
                subElement.collapseAll();
              }
            });
          }

          // Bloquear expansión de hijos para productos sin permiso
          if (node.hasChildren && !this.navbarChildrenVisibility.shouldShowChildren(node.data.product)) {
            return;
          }

          if (node.hasChildren){
            node.toggle();
          }else{
            // Es un nodo hoja (sin hijos) - marcarlo como activo y mantener padres expandidos
            this.currentUrl = node.data.id;
            
            // Marcar este nodo como activo
            tree.focusNode(node);
            
            // Asegurar que todos los padres estén expandidos
            let parent = node.parent;
            while (parent) {
              if (!parent.isExpanded) {
                parent.expand();
              }
              parent = parent.parent;
            }
          }
        }
      }
    },
    allowDrag: (node: TreeWrapperNode) => {
      return false;
    },
    allowDrop: (node: TreeWrapperNode) => {
      return false;
    },
    animateExpand: true,
    animateSpeed: 100,
  }
  statusNavbar;
  showCollapseLabel = true;
  modal: NgbModalRef;
  modalPMS: NgbModalRef;
  displayStates = true;
  #_sideBarCollapsed = false;
  #_isMobile = false;

  set sideBarCollapsed(value) {
    this.#_sideBarCollapsed = value;
    const timeMs = this.#_sideBarCollapsed ? 100 : 400;
    setTimeout(() => {
      this.showCollapseLabel = !this.#_sideBarCollapsed;
    }, timeMs);
  }

  get sideBarCollapsed() {
    return this.#_sideBarCollapsed;
  }

  @Input() isMenuOpen;

  @Input() set isMobile (value: boolean) {
    this.#_isMobile = value;
    this.stateChange();
  }

  get isMobile() {
    return this.#_isMobile;
  }

  loadingOtas = true;
  chainOtasErrors = [];
  @Select(OtasState.chainOtasErrors) chainOtasErrors$: Observable<any>;
  @Select(CustomersState.currentCustomer) currentCustomer$: Observable<any>;
  @Select(MenusState.currentMenuSidebar) menuState$: Observable<any>;

  loadingOtaStatus = true;
  currentOta = '';

  constructor(
    private utilService: UtilService,
    private productsService: ProductsService,
    private adminAlertsService: AdminAlertsService,
    private notificationsService: NotificationsService,
    private navbarService: NavbarService,
    private navbarChildrenVisibility: NavbarChildrenVisibilityService,
    private adminCustomerService: AdminCustomerService,
    private modalService: NgbModal,
    private store: Store,
    private router: Router,
    private sessionService: SessionService,
    private cdr: ChangeDetectorRef,
  ){ }

  handleIntegration($event) {
    if ($event) {
      this.utilService.customerChanged($event.customer);
      this.currentOta = $event.otaId === 31 ? 'facebook'
      : this.currentOta = $event.otaId === 2 ? 'booking'
      : this.currentOta = $event.otaId === 1 ? 'tripadvisor'
      : this.currentOta = $event.otaId === 34 ? 'expedia'
      : 'google';
      this.utilService
        .isLoadCustomerReady()
        .pipe(take(1))
        .subscribe(() => {
          setTimeout(() => {
            this.router.navigate([`/online/integraciones/${this.currentOta}`]);
          });
        });
    }
  }

  updateStatus(status) {
    this.navbarService.setStatus(status);
    // Recargar el menú cuando cambia el status
    this.loadMenu();
    
    // Después de recargar, aplicar las configuraciones
    setTimeout(() => {
      if (status === 0) {
        if (this.treeModel) {
          this.treeModel.collapseAll();
        }
      }
      if (this.sideBarCollapsed) {
        this.sideBarCollapsed = false;
        this.utilService.toggleNavbar(this.sideBarCollapsed);
      }
    }, 600);
  }

  updateCustomerLogo(customer: any = null): void {
    if(customer) this.currentCustomerLogo = customer?.urlLogo;
    else {
      const currentCustomer = this.utilService.getCurrentHotel();
      this.currentCustomerLogo = currentCustomer.urlLogo;
    }
  }

  setCurrentNavbar(){
    if (!this.treeComponent || !this.treeComponent.treeModel) {
      return;
    }
    
    if (this.currentUrl !== this.utilService.currentSection || this.statusNavbar === 0) {
      this.currentUrl = this.utilService.currentSection;
      this.treeModel = this.treeComponent.treeModel;
      if (this.statusNavbar === 3) {
        const firstNode = this.treeModel.getFirstRoot();
        if (firstNode) {
          firstNode.expand();
        }
      }
    } else {
      this.treeModel = this.treeComponent.treeModel;
      if (this.statusNavbar === 3) {
        const firstNode = this.treeModel.getFirstRoot();
        if (firstNode) {
          firstNode.expand();
        }
      } else {
        this.treeModel.expandAll();
      }
    }
  }

  async storeCustomers(customer) {
    const userId = this.currentUser.id;
    await this.sessionService.storeCustomers(customer, userId);
  }

  herachyUrl(url){
    if(url){
      let lastIndex = url.lastIndexOf("/");
      let pattern = url.substring(0,lastIndex)+'/*';
      let actions   = ['edit/'];
      for(let action of actions){
        pattern = pattern.replace(action,'');
      }
      return pattern;
    }
    return '';
  }

  async ngOnInit() {
    this.utilService.subjectExpandAll.subscribe((value) => {
      if (value && this.treeModel) {
        const selectedNode = this.treeModel.getNodeById(value);
        if (selectedNode) {
          selectedNode.expand();
        }
      }
    });
    this.util = this.utilService;
    this.updateCustomerLogo();
    this.statusNavbar = this.navbarService.getStatus();
    const status = this.navbarService.getStatus();
    await this.productsService.loadSidebarMenu(status);
    this.nodes = this.applyChildrenVisibility(this.productsService.getNavbarItems());
    this.subscriptions = new Subscription();
    
    // Inicializar concierge como bloqueado hasta que el guard valide
    this.navbarChildrenVisibility.setChildrenVisibility('concierge', false);
    
    // Suscribirse a cambios de visibilidad de hijos
    this.subscriptions.add(
      this.navbarChildrenVisibility.visibilityConfig$.subscribe((config) => {
        if (this.treeComponent?.treeModel) {
          config.forEach((showChildren, product) => {
            if (!showChildren) {
              // Colapsar nodos del producto que no debe mostrar hijos
              this.treeComponent.treeModel.roots?.forEach(root => {
                root.children?.forEach(child => {
                  if (child.data?.product === product && child.isExpanded) {
                    child.collapse();
                  }
                });
              });
            }
          });
        }
      })
    );
    
    // Guardar la URL actual para restaurar después
    this.currentUrl = this.utilService.currentSection;

    this.initListeners();
    this.currentUser = this.utilService.getCurrentUser();
    this.is_super_admin = this.currentUser.isSuperAdmin();
    this.is_admin = this.currentUser.admin;
    this.user_role = this.utilService.currentUser.role;
    this.loadOtasErrors();
    this.chainOtasErrors = this.store.selectSnapshot(OtasState.chainOtasErrors);
    
    // Restaurar el nodo activo después de inicializar
    setTimeout(() => {
      this.restoreActiveNode();
    }, 100);
  }

  private applyChildrenVisibility(nodes: NavbarNode[]): NavbarNode[] {
    return nodes;
  }

  ngOnDestroy() {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }

  loadMenu() {
    const newStatus = this.navbarService.getStatus();
    // Early return just in case we are in the concierge introduction page and the status has not changed
    if (this.router.url.startsWith('/concierge/introduction') && this.statusNavbar === newStatus) {
      return;
    }

    
    this.isLoading = true;
    this.nodes = null;
    setTimeout(async () => {
      const status = this.navbarService.getStatus();
      await this.productsService.loadSidebarMenu(status);
      let nodes = this.productsService.getNavbarItems();
      if (nodes === null || nodes === undefined || nodes.length === 0) {
        await this.productsService.loadSidebarMenu(status);
        nodes = this.productsService.getNavbarItems();
      }
      
      // Aplicar filtro de visibilidad de hijos
      this.nodes = this.applyChildrenVisibility([...nodes]);
      
      this.isLoading = false;
      
      // Después de cargar el menú, restaurar el nodo activo si existe
      setTimeout(() => {
        this.restoreActiveNode();
      }, 100);
    }, 500);
  }

  private restoreActiveNode(): void {
    if (!this.treeComponent || !this.treeComponent.treeModel || !this.currentUrl) {
      return;
    }
    
    const currentNode = this.treeComponent.treeModel.getNodeById(this.currentUrl);
    if (currentNode) {
      // Marcar el nodo como activo
      this.treeComponent.treeModel.focusNode(currentNode);
      
      // Expandir todos los padres
      let parent = currentNode.parent;
      while (parent) {
        if (!parent.isExpanded) {
          parent.expand();
        }
        parent = parent.parent;
      }
    }
  }

  isCurrent(item: NavbarNode | TreeWrapperNode): boolean {
    if (!this.currentUrl) {
      return false;
    }
    
    const isLeaf = item instanceof TreeWrapperNode ? item.isLeaf : !item.isParent();
    const depth = item instanceof TreeWrapperNode ? item.data.depth : item.depth;
    const itemId = item instanceof TreeWrapperNode ? item.data.id : item.id;
    const herachyUrl = this.herachyUrl(this.currentUrl);
    
    // LÓGICA PARA CORPORATIVO
    // En modo corporativo, marcar como activo tanto los nodos hoja como los padres en la ruta activa
    if (this.isCorporative) {
      // Para nodos hoja, funciona igual que antes
      if (isLeaf && depth >= 1) {
        return itemId === this.currentUrl || itemId === herachyUrl;
      }
      
      // Para nodos padre en corporativo, verificar si algún hijo está activo
      // Es decir, si el currentUrl comienza con el id del nodo padre
      if (!isLeaf && depth >= 1) {
        // Verificar si este nodo padre está en la ruta del nodo activo
        return this.currentUrl.startsWith(itemId) || herachyUrl.startsWith(itemId);
      }
      
      return false;
    }
    
    // LÓGICA ORIGINAL PARA OTROS MODOS
    // Solo marcar como activo si es un nodo hoja (no padre) Y de nivel 2 o superior
    if (!isLeaf || depth < 1) {
      return false;
    }
    
    return itemId === this.currentUrl || itemId === herachyUrl;
  }

  refresh(){
    if (this.treeComponent) {
      this.treeModel = this.treeComponent.treeModel;
      this.setCurrentNavbar();
    }
  }

  stateChange(event = null): void {
    const tree = event?.treeModel || this.treeComponent?.treeModel;
    if (this.windowsInnerHeight > this.SMALL_HEIGHT_RESOLUTION) {
      this.displayStates = true;
      return;
    }

    if (this.windowsInnerHeight < this.EXTRA_SMALL_HEIGHT_RESOLUTION) {
      this.displayStates = false;
      return;
    }

    if (tree?.expandedNodeIds && Object.keys(tree.expandedNodeIds).length) {
      const status = [];
      Object.keys(tree.expandedNodeIds).forEach((key) => {
          status.push(tree.expandedNodeIds[key]);
      });
      this.displayStates = !status.some(value => value);
    } else {
      this.displayStates = true;
    }
  }

  updateData(event){
    if (this.treeComponent && this.treeComponent.treeModel) {
      this.treeModel = this.treeComponent.treeModel;
    }
    this.refresh();
  }

  changeFilter($event){
  }

  get isRetail(){ return this.utilService.customerIsRetail}
  get isCorporative() { return this.navbarService.getStatus() === 3 }

  collapseSidenav() {
    if (!this.isCollapsing) {
      this.isCollapsing = true;
      this.sideBarCollapsed = !this.sideBarCollapsed;
      this.utilService.toggleNavbar(this.sideBarCollapsed);

      if (this.collapseSidenav) {
        this.treeModel.collapseAll();
      }
      this.setShowStates();
    }
  }

  setStatus(value: number): void {
    this.updateStatus(value);
    this.sideBarCollapsed = false;
    this.utilService.toggleNavbar(this.sideBarCollapsed);
    this.treeModel.collapseAll();
    this.setShowStates();
  }

  initListeners() {
    this.subscriptions.add(
      this.chainOtasErrors$.subscribe((chainOtasErrors) => {
        if( !chainOtasErrors ) return;
        this.chainOtasErrors = chainOtasErrors;
        this.loadingOtaStatus = false;
        this.cdr.detectChanges();
      }),
    );

    this.subscriptions.add(
      this.menuState$.subscribe((menus) => {
        this.showIntegrationState = menus.sidebar.some((menu) => menu.slug === 'status_integrations');
        this.cdr.detectChanges();
      }),
    );

    this.subscriptions.add(
      this.utilService.isCustomerChanged().subscribe(() => {
        this.loadMenu();
        this.loadOtasErrors();
      }),
    );

    const isCustomerChangedSubs = this.utilService.isCustomerChanged().subscribe(hotel => {
      this.navbarService.setStatus(0);
      const customerId = hotel.id.toString();

      if(this.utilService.getAferCustomerId() !== customerId){
        this.notificationsService.deleteResponseAlert();
        this.utilService.setAfterCustomerId(customerId);
      }
      this.updateCustomerLogo(hotel);
      this.utilService.toggleNavbar(this.sideBarCollapsed);
      
      // Resetear visibilidad de children de concierge al cambiar de cliente
      this.navbarChildrenVisibility.setChildrenVisibility('concierge', false);
      
      // Redirigir al dashboard si está en concierge
      if (this.router.url.startsWith('/concierge/')) {
        this.router.navigate(['/dashboard']);
      }
    });
    this.subscriptions.add(isCustomerChangedSubs);

    const isStatusChangedSubs = this.navbarService.isStatusChanged()
      .pipe(
        filter((response) => !isNaN(response)),
        distinctUntilChanged(),
      ).subscribe(response => {
        this.loadMenu();
        setTimeout(async () => {
          if (this.sideBarCollapsed) {
            this.sideBarCollapsed = false;
            this.utilService.toggleNavbar(this.sideBarCollapsed);
          }
          this.statusNavbar = response;
          if (this.isCorporative) {
            this.loadingOtaStatus = true;
            try {
              await this.storeCustomers(this.currentCustomer);
              await this.loadChainOtasErrors();
            } catch (error) {
              console.error(error);
            } finally {
              this.loadingOtaStatus = false;
            }
          }
        }, 0);
      });
    this.subscriptions.add(isStatusChangedSubs);

    const isToggleNavbarSubs = this.utilService.isToggleNavbar().subscribe((value) => {
      this.sideBarCollapsed = value;
      this.setShowStates();
    });
    this.subscriptions.add(isToggleNavbarSubs);

    const isNavbarChangedSubs = this.utilService.isNavbarChanged().subscribe(() => {
      this.currentUrl = this.utilService.currentSection;
      this.restoreActiveNode();
    });
    this.subscriptions.add(isNavbarChangedSubs);
  }

  updateCustomerReady(hotel,emit=true){
    this.utilService.customerChanged(hotel,emit);
  }

  async loadOtasErrors() {
    this.loadingOtaStatus = true;
    this.otasErrors = null;
    this.cdr.detectChanges();
    try {
      const response: any = await this.adminCustomerService.getChainStatus(this.currentCustomer.id).toPromise();
      if (response?.length > 0) {
        this.otasErrors = response;
      } else {
        this.otasErrors = [];
      }
    } catch (error) {
      console.error(error);
      this.otasErrors = [];
    } finally {
      this.loadingOtaStatus = false;
      this.cdr.detectChanges();
    }
  }

  async loadChainOtasErrors() {
    const relativeChain = this.relativeCurrentChain;
    if (relativeChain && relativeChain.length > 0) {
      const ids = relativeChain.map((c) => c.id);
      const response: any = await this.adminCustomerService.getChainStatus(ids).toPromise();
      if (response && response.status) {
        this.store.dispatch(new StoreChainOtasErrors(response.status));
      }
      this.loadingOtaStatus = false;
      this.cdr.detectChanges();
    }
  }

  get currentCustomer() {
    return this.utilService.getCurrentCustomer();
  }

  get customerId() {
    return this.utilService.getCurrentCustomer().id;
  }

  get statusState() {
    return this.sideBarCollapsed ? 'collapse' : 'expand';
  }

  setShowStates() {
    const msTime = this.sideBarCollapsed ? 0 : 400;
    setTimeout(() => {
      this.showStates = !this.sideBarCollapsed;
      this.isCollapsing = false;
    }, msTime);
  }

  get windowsInnerWidth() {
    return window.innerWidth;
  }

  get windowsInnerHeight() {
    return window.innerHeight;
  }

  get marginTopStatus() {
    if (this.windowsInnerHeight <= this.SMALL_HEIGHT_RESOLUTION) return '40';
    if (this.windowsInnerHeight <= this.MEDIUM_HEIGHT_RESOLUTION) return '80';
    return '193';
  }

  get paddingTop() {
    if (this.isMobile) return '37';
    return this.windowsInnerHeight <= this.SMALL_HEIGHT_RESOLUTION || this.isCorporative || this.statusNavbar !== 0 ? '0' : '37';
  }

  openOtaStatusModal() {
    this.modal = this.modalService.open(this.statusOTA, {
      size: 'md'
    });
  }

  openPMSStatusModal() {
    this.modalPMS = this.modalService.open(this.statusPMS, {
      size: 'md'
    });
  }

  getTranslateTypeError(ota: OtasErrors) {
    return `admin.otas.error.${ota.error.public_error ? 'public' : 'internal'}`;
  }

  get currentLanguage() {
    return this.utilService.getCurrentLanguage();
  }

  get manualLink() {
    return MANUAL_GOOGLE_FB.find(m => m.language === this.currentLanguage)?.link;
  }

  getAllNotMobileIDs(node: NavbarNode) {
    let ids: any[] = [];
    if (node.children.length) {
      node.children.forEach((childNode: NavbarNode) => {
        if (!childNode.mobile) {
          ids.push(childNode.id);
        }
        ids = ids.concat(this.getAllNotMobileIDs(childNode));
      });
    }
    return ids;
  }

  checkMobileSubItems() {
    if (this.treeModel) {
      const nodesToCheck = this.treeModel.roots.length === 1 && this.treeModel.roots[0].children.length 
        ? this.treeModel.roots[0].children.map(c => c.data) 
        : this.treeModel.roots.map(r => r.data);
        
      nodesToCheck.forEach(node => {
        const mobileNodesIDs = this.getAllNotMobileIDs(node);
        if (mobileNodesIDs.length) {
          mobileNodesIDs.forEach(id => {
            const foundNode = this.treeModel.getNodeById(id);
            if (foundNode) {
              if (this.isMobile) {
                foundNode.hide();
              } else {
                foundNode.show();
              }
            }
          });
        }
      });
    }
  }

  get relativeCurrentChain() {
    return this.store.selectSnapshot(CustomersState.relativeCurrentChain);
  }

  get menuContext() {
    return this.statusNavbar === 3 ? 'corporative' : 'general';
  }
}
